// REDUCER FOR COMPANY LIST
export function removeContinuingJob(state = [], action) {
    switch (action.type) {
        case 'REMOVE_CONTINUING_JOB':
        console.log(action.data)
            return action.data
        default:
            return state
    }
}